import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'outputs',
            name: 'output',
            class: 'Modules\\Site\\Entities\\Output'
        }
    }
}